import { useInstancesByClassName } from 'hive-react-utils';
export function useCoachingTips() {
    return useInstancesByClassName('ecarepd', 'coachingTip', {});
}
